import type { ReactNode } from 'react'
import { cn } from '@/utils/cn'

export interface TabDef {
  key: string
  label: string
  icon: ReactNode
}

interface TabNavigationProps {
  tabs: TabDef[]
  activeTab: string
  onTabChange: (key: string) => void
}

export function TabNavigation({ tabs, activeTab, onTabChange }: TabNavigationProps) {
  return (
    <div className="monitoring-tabs">
      {tabs.map((tab) => (
        <button
          key={tab.key}
          type="button"
          onClick={() => onTabChange(tab.key)}
          className={cn('monitoring-tab-btn', activeTab === tab.key && 'active')}
          aria-current={activeTab === tab.key ? 'page' : undefined}
        >
          <span className="monitoring-tab-icon" aria-hidden>
            {tab.icon}
          </span>
          <span>{tab.label}</span>
        </button>
      ))}
    </div>
  )
}
